const PRIVATE_QUERY_PARAM = /^(email|emailChangeCode|code|token|.*client_secret|password|invitedBy|team)$/i;
const PRIVATE_AUTH_PATHS = new Set(['/auth/finish-registration', '/auth/password-reset', '/auth/email-change']);

/** Auth links must keep working on refresh, but no optional SDK may read their URLs. */
export function isPrivateTrackingUrl(href: string): boolean {
  try {
    const url = new URL(href, 'https://app.digidoo.com');
    return (
      PRIVATE_AUTH_PATHS.has(url.pathname.replace(/\/+$/, '')) ||
      [...url.searchParams.keys()].some((key) => PRIVATE_QUERY_PARAM.test(key))
    );
  } catch {
    return true;
  }
}

export function canLoadTracking(): boolean {
  return typeof window === 'undefined' || !isPrivateTrackingUrl(window.location.href);
}

/** Only campaign parameters belong in analytics URLs; never auth codes or Stripe return secrets. */
export function sanitizeTrackingUrl(href: string): string {
  if (!href) return '';
  try {
    const url = new URL(href, window.location.origin);
    for (const key of [...url.searchParams.keys()]) {
      if (!key.startsWith('utm_')) url.searchParams.delete(key);
    }
    url.hash = '';
    return url.toString();
  } catch {
    return '';
  }
}
